<template>
    <div class="containerTextSelect">
        <label :for=label>{{ labelFormatted }}</label>
        <input type="text"
               :value="value"
               :required="required"
               id="postalCodeSelect"
               @input="event => $emit('update', event.target.value)"
        >
    </div>
</template>

<script>
import {computed, defineComponent, ref, watch, onMounted} from "vue";
import autocomplete from 'autocompleter';
import AutocompleteAPI from '@/api/resources/autocomplete';

const selectedValue = ref('')
export default defineComponent({
    name: 'textSelectInputField',
    emits: ['update'],
    props: {
        label: {
            type: String,
            required: false,
            default: ""
        },
        value: {
            type: Object,
        },
        id: {
            type: String,
            required: false,
            default: ""
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        emptyMsg: {
            type: String,
            required: false,
            default: 'Geen resultaten gevonden'
        }
    },
    setup(props, {emit}) {
        const labelFormatted = computed(() => {
            return props.label;
        })

        watch(selectedValue, async (newVal, oldVal) => {
            let postal = newVal ? newVal : oldVal
            emit('update', postal)
        })

        onMounted(() => {
            const input = document.getElementById('postalCodeSelect');

            autocomplete({
                input: input,
                className: 'autocomplete',
                emptyMsg: props.emptyMsg,
                debounceWaitMs: 100,
                fetch: async function (text, update) {
                    text = text.toLowerCase();
                    let zipcodes = await AutocompleteAPI.zipcodes(text)
                    update(zipcodes);
                },
                render: function (item) {
                    let div = document.createElement('div');
                    div.textContent = item;
                    div.className = 'listItem'
                    return div;
                },
                onSelect: function (item) {
                    input.value = item;
                    selectedValue.value = item
                }
            });
        })

        return {
            labelFormatted
        }
    }
})
</script>

<style lang="scss">
.containerTextSelect {
  display: flex;
  flex-direction: column;
}

.containerTextSelect > label {
  margin-bottom: 5px;
}

.autocomplete.autocomplete {
  background-color: white !important;
  cursor: pointer;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  margin-top: 5px;

  max-height: 200px !important;
  overflow-y: auto;
  overflow-x: hidden;
  z-index:3000 !important;
}

div.empty {
  cursor: not-allowed;
}

.listItem {
  transition: padding-left 250ms ease-in-out;
}

.listItem, div.empty {
  padding: 5px 0 5px 5px;
}

.listItem:not(:first-of-type) {
  margin-top: 2px;
}

.listItem:hover, .listItem.selected {
  background-color: whitesmoke;
}

.listItem:hover {
  padding-left: 10px;
  transition: padding-left 250ms ease-in-out;
}
</style>